import axios from '../api/axios';

export async function getImageRequests(pagination = {}, options = {}) {
  const headers = {};
  if (pagination.page) headers['page'] = pagination.page;
  if (pagination.total) headers['limit'] = pagination.total;

  options.headers = { ...(options.headers || {}), ...headers };

  const res = await axios.get(`/images-requests`, options);

  const payload = res.data;
  const imageRequests =
    payload?.imagesRequests || payload?.results || payload?.items || payload || [];
  const count = payload?.count || (Array.isArray(imageRequests) ? imageRequests.length : 0);

  return { imageRequests, count };
}

export async function updateImageRequest(imageRequestId, body) {
  const res = await axios.patch(
    `/images-requests/${imageRequestId}`,
    JSON.stringify(body),
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
  return res.data;
}

export async function deleteImageRequest(imageRequestId) {
  const res = await axios.delete(`/images-requests/${imageRequestId}`);
  return res.data;
}

